module.exports = __webpack_public_path__ + "static/media/iot3.7ec80b34.jpg";